;(() => {
  // Cooldown after a programmatic scroll settles, covering the trailing reflow
  // that still emits synthetic pointer events under a stationary cursor.
  const SCROLL_SETTLE_MS = 200
  let scrollSettleTimer = null

  function animateScroll(
    container,
    { scrollTop, scrollLeft },
    speed,
    callback,
  ) {
    if (window.matchMedia?.("(prefers-reduced-motion: reduce)")?.matches) {
      if (scrollTop != null) container.scrollTop = scrollTop
      if (scrollLeft != null) container.scrollLeft = scrollLeft
      if (callback) callback()
      return
    }

    // Cancel any in-flight scroll animation on this element
    if (container._scrollAnimId) cancelAnimationFrame(container._scrollAnimId)

    const start = { top: container.scrollTop, left: container.scrollLeft }
    const delta = {
      top: scrollTop != null ? scrollTop - start.top : 0,
      left: scrollLeft != null ? scrollLeft - start.left : 0,
    }

    if (Math.abs(delta.top) < 1 && Math.abs(delta.left) < 1) {
      if (callback) callback()
      return
    }

    const startTime = performance.now()

    function step(now) {
      const elapsed = now - startTime
      const progress = Math.min(elapsed / speed, 1)
      const eased = 0.5 - Math.cos(progress * Math.PI) / 2

      if (scrollTop != null) container.scrollTop = start.top + delta.top * eased
      if (scrollLeft != null)
        container.scrollLeft = start.left + delta.left * eased

      if (progress < 1) {
        container._scrollAnimId = requestAnimationFrame(step)
      } else {
        container._scrollAnimId = null
        if (callback) callback()
      }
    }

    container._scrollAnimId = requestAnimationFrame(step)
  }

  const viewport = {
    scrollToOptions: {
      offset: -100,
      speed: 300,
      animate: true,
      callback: () => {},
    },

    scrollTo(el, options = {}) {
      if (el.length < 1) {
        return
      }

      let container = $("html, body")
      let scrollTopContainerCorrection = 0
      let scrollLeftContainerCorrection = 0

      if (options.containerSelector) {
        const containerFromOptions = el.closest(options.containerSelector)
        if (containerFromOptions.length > 0) {
          container = containerFromOptions
          scrollTopContainerCorrection =
            container[0].scrollTop - this.elTop(container)
          scrollLeftContainerCorrection =
            container[0].scrollLeft - this.elLeft(container)
        }
      }

      const offset = options.offset ?? this.scrollToOptions.offset
      const speed = options.speed ?? this.scrollToOptions.speed
      const animate = options.animate ?? this.scrollToOptions.animate
      const callback = options.callback ?? this.scrollToOptions.callback

      // Mark the page as programmatically scrolling so hover-driven tooltips
      // ignore the synthetic mouseenter events fired as content moves under a
      // stationary cursor.
      this.markScrolling(animate ? speed + SCROLL_SETTLE_MS : SCROLL_SETTLE_MS)

      const newScrollTop =
        this.elTop(el) + offset + scrollTopContainerCorrection
      const newScrollLeft =
        this.elLeft(el) + offset + scrollLeftContainerCorrection

      if (animate) {
        const rawContainer =
          container[0] === document.documentElement ||
          container[0] === document.body
            ? document.documentElement
            : container[0]

        animateScroll(
          rawContainer,
          { scrollTop: newScrollTop, scrollLeft: newScrollLeft },
          speed,
          callback,
        )
      } else {
        container[0].scrollTop = newScrollTop
        container[0].scrollLeft = newScrollLeft
        callback()
      }
    },

    markScrolling(durationMs) {
      this._scrollingUntil = performance.now() + durationMs
      clearTimeout(scrollSettleTimer)
      scrollSettleTimer = setTimeout(() => {
        this._scrollingUntil = 0
      }, durationMs)
    },

    isScrolling() {
      return performance.now() < (this._scrollingUntil || 0)
    },

    elTop(el) {
      return el.offset().top
    },

    elLeft(el) {
      return el.offset().left
    },

    top() {
      return window.pageYOffset
    },

    bottom() {
      return this.top() + window.innerHeight
    },

    left() {
      return window.pageXOffset
    },

    right() {
      return this.left() + window.innerWidth
    },
  }

  window.Viewport = viewport
})()
